import http from '@/utils/http';

export default {
	list: data => http({ url: '/api/admin/v1/vehicle/list', data }),
	poolList: data => http({ url: '/api/admin/v1/vehicle/poolList', data }),
	detail: data => http({ url: '/api/admin/v1/vehicle/detail', data }),
	poolDetail: data => http({ url: '/api/admin/v1/vehicle/poolDetail', data }),
	ocrDrivingLicense: data => http({ url: '/api/admin/v1/vehicle/ocrDrivingLicense', data }),
	create: data => http({ url: '/api/admin/v1/vehicle/create', data, tip: true }),
	update: data => http({ url: '/api/admin/v1/vehicle/update', data, tip: true }),
	delete: data => http({ url: '/api/admin/v1/vehicle/delete', data, tip: true }),
	toggleStatus: data => http({ url: '/api/admin/v1/vehicle/toggleStatus', data, tip: true }),
	uploadImage: data => http({ url: '/api/admin/v1/vehicle/uploadImage', data, files: true }),
};
